import React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'

import './styles/global.css'
import './styles/interFont.css'

import './utils/yupExtensions'

const root = document.getElementById('root')!

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
